module.exports = __webpack_public_path__ + "img/P50-zh.f9aed012.png";